import { extractMessageContent } from './messageContent';

export function formatRequestDuration(startISO, endISO) {
  if (!startISO) return '0:00';
  const start = new Date(startISO).getTime();
  const end = endISO ? new Date(endISO).getTime() : Date.now();
  const sec = Math.max(0, Math.floor((end - start) / 1000));
  const m = Math.floor(sec / 60);
  const s = sec % 60;
  return `${m}:${s.toString().padStart(2, '0')}`;
}

function formatThinkingHistoryHeader(request) {
  if (!request || typeof request !== 'object') return '';
  const status = String(request.status || 'unknown').toLowerCase();
  const time = formatRequestDuration(request.created_at, request.modified_at);
  return `Status: ${status} • Time: ${time}`;
}

export function formatThinkingHistoryAudit(items, { includeVerboseMetadata = false, request } = {}) {
  const list = Array.isArray(items) ? items : [];
  const parts = [];

  const header = formatThinkingHistoryHeader(request);
  if (header) parts.push(header);

  if (list.length === 0) {
    return parts.join('\n\n');
  }

  const sorted = [...list].sort((a, b) => new Date(a.created_at) - new Date(b.created_at));
  const body = sorted.map((entry, index) => {
    const lines = [`[${index + 1}] ${String(entry.reasoning || '').trim()}`];
    if (includeVerboseMetadata && entry.metadata && typeof entry.metadata === 'object') {
      try {
        lines.push(JSON.stringify(entry.metadata, null, 2));
      } catch (_) {
        lines.push(String(entry.metadata));
      }
    }
    return lines.join('\n');
  }).join('\n\n');

  parts.push(body);
  return parts.join('\n\n');
}

export function collectRequestReplyText(request, messages = []) {
  const ids = Array.isArray(request?.response_messages) ? request.response_messages : [];
  if (ids.length === 0) return '';

  const byId = new Map((messages || []).map((m) => [m.message_id, m]));
  const parts = [];
  for (const id of ids) {
    const row = byId.get(id);
    if (!row || !row.is_agent) continue;
    const text = extractMessageContent(row).trim();
    if (text) parts.push(text);
  }
  return parts.join('\n\n');
}
